import { FooterComponent } from '../components/footer/footer.component';
import { CustomMenuItemDetailComponent } from './../components/menu/custom-menu-item-detail.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';

export const footerRoutes = {
    path: 'footer',
    component: FooterComponent,
    data: {
        breadcrumbs: {
            label: 'Patička',
            icon: 'menu'
        },
        state: 'footer'
    },
    children: [
        {
            path: 'custom/:lang',
            component: CustomMenuItemDetailComponent,
            data: {
                breadcrumbs: {
                    label: 'Přidat vlastní položku menu'
                },
                state: 'custom-menu-items-add',
                redirect: 'footer'
            },
            outlet: 'modal'
        },
        {
            path: 'custom-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat položku'
                },
                state: 'custom-delete',
                apiUri: 'custom-menu-items'
            },
            outlet: 'modal'
        }
    ]
};
